import Home from './index.vue'

export default [
  {
    path: '/',
    name: 'Home',
    component: Home
  }
]
